import { render } from "./DocumentClassView.vue?vue&type=template&id=22e8c078&scoped=true&ts=true"
import script from "./DocumentClassView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassView.vue?vue&type=script&lang=ts"

import "./DocumentClassView.vue?vue&type=style&index=0&id=22e8c078&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e8c078"]])

export default __exports__